/* global axios */
import ApiClient from '../ApiClient';

class CaptainScenarios extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId, page = 1, searchKey } = {}) {
    return axios.get(`${this.url}/${assistantId}/scenarios`, {
      params: { page, searchKey },
    });
  }

  show({ assistantId, id }) {
    return axios.get(`${this.url}/${assistantId}/scenarios/${id}`);
  }

  create({ assistantId, ...data } = {}) {
    return axios.post(`${this.url}/${assistantId}/scenarios`, {
      scenario: data,
    });
  }

  update({ assistantId, id }, data = {}) {
    return axios.put(`${this.url}/${assistantId}/scenarios/${id}`, {
      scenario: data,
    });
  }

  delete({ assistantId, id }) {
    return axios.delete(`${this.url}/${assistantId}/scenarios/${id}`);
  }

  regenerate({ assistantId }) {
    return axios.post(`${this.url}/${assistantId}/scenarios/regenerate`);
  }

  preview({ assistantId, templateId }) {
    return axios.get(`${this.url}/${assistantId}/scenarios/preview`, {
      params: { template_id: templateId },
    });
  }

  toggleMode({ assistantId, id, generationMode }) {
    return axios.patch(`${this.url}/${assistantId}/scenarios/${id}/toggle_mode`, {
      generation_mode: generationMode,
    });
  }

  previewVisual({ assistantId, id, visualConfig }) {
    const scenarioId = id || 'preview';
    return axios.post(`${this.url}/${assistantId}/scenarios/${scenarioId}/preview_liquid`, {
      visual_config: visualConfig,
    });
  }
}

export default new CaptainScenarios();
